<template>
    <div style="">
        <div style="margin: auto;width: 375px;border: 1px solid #eee;overflow: auto; position: relative;background: white;box-shadow: rgba(0, 0, 0, 0.21) 0px 5px 15px 0px;margin-bottom: 10px; border-radius: 5px">
            <div :style="{'background-image': 'url(\'/static/img/assets/facebook_ui/iOS Nav Bot.png\')'}" style="width:100%;min-height: 64px;border-bottom: 1px solid #eee">
                <div style="padding-top: 23px;text-align: center;">
                    <span style="color: black">{{pagename | truncate(13)}}</span> >
                    <div class="small">Typically replies instantly</div>
                </div>
            </div>

            <div style="padding: 10px; min-height: 250px; max-height: 603px; overflow-x: hidden; overflow-y: auto">

                <slot name="body"></slot>
            </div>
            <slot name="quick_reply"></slot>
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['pagename']
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/elements/FacebookScreen.vue